import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const dark = tone === 'dark';
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-114" data-mp="3c3yysrhwio94">
      <p className={`flex items-center gap-2 text-sm font-bold uppercase tracking-wider ${dark ? 'text-radar' : 'text-alert-deep'}`} data-id="element-115" data-mp="3h2k1qyojfm19">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-116" data-mp="371zvtiq2ptcp" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-117" data-mp="10c3d5gjo1fzd">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-118" data-mp="15bogs49s6cif" data-mpi={i}>
            {i > 0 && <span className={`pt-3 font-display text-3xl font-bold ${dark ? 'text-white/60' : 'text-navy-900/50'}`} data-id="element-119" data-mp="y16i72aoprn0">
                :
              </span>}
            <div className="flex flex-col items-center" data-id="element-120" data-mp="szzdxd7r3al3">
              <span className={`flex h-[4.25rem] w-[4.5rem] items-center justify-center rounded-xl font-display text-4xl font-bold tabular-nums sm:h-20 sm:w-20 sm:text-5xl ${dark ? 'bg-white text-navy-900' : 'bg-navy-900 text-white'}`} data-id="element-121" data-mp="17py8l603k3vt">
                {unit.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-widest ${dark ? 'text-white/70' : 'text-muted'}`} data-id="element-122" data-mp="a5kejmhj1fwq">
                {unit.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}